import React, { useEffect, useMemo, useState } from 'react'
import MasterService from '../../../../services/master/MasterService'
import NonlalinService from '../../../../services/nonlalin/NonlalinService'
import { Button, Modal, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'
import { FaArrowLeft, FaChevronCircleLeft, FaChevronLeft, FaEdit, FaEye, FaMinus, FaPlus, FaRegPlusSquare, FaSave, FaTrash } from 'react-icons/fa'
import DataTable from 'react-data-table-component'
import SweetAlert from 'react-bootstrap-sweetalert'
import { AsyncPaginate } from 'react-select-async-paginate'
// import JenisSatuan from '../../../../utilities/JenisSatuan'
import Bentuk from '../../../../utilities/Bentuk'
import ExpandableComponentNonLalinPeriksa from '../../expand/ExpandableComponentNonLalinPeriksa'
import ModalTargetUji from '../../modal/ModalTargetUji'

const ViewNonLalinDetil = ({ dataDetil, saveDetil, cancelDetil }) => {
    const [showAddKomoditi, setShowAddKomoditi] = useState(false);
    const handleCloseAddKomoditi = () => {
        setValueSeri(0)
        setValueIkanOpt(null)
        setValueIdIkan(null)
        setValueHsCode(null)
        setValueBentuk(null)
        setValueNmDagang(null)
        setValueNmUmum(null)
        setValueSatuan(null)
        setValuePopulasi(null)
        setValueKdTarif(null)
        setShowAddKomoditi(false);
    }
    const handleShowAddKomoditi = () => {
        setValueSeri(0)
        setShowAddKomoditi(true)
    }
    const [showEditKomoditi, setShowEditKomoditi] = useState(false);
    const handleCloseEditKomoditi = () => setShowEditKomoditi(false);
    const handleShowEditKomoditi = async (row) => {
        // console.log(row)
        // setDetilKomoditi(row)
        if ((localStorage.getItem('role') === '4' || localStorage.getItem('role') === '5')) {
            const resIKan = await masterService.getMasterIkanById(row.idIkan)
            setValueIkanOpt(resIKan.data)
        }
        setValueSeri(row.trNonlalinDtlPK.seri)
        setValueIdIkan(row.idIkan)
        setValueNmDagang(row.namaLokal)
        setValueNmUmum(row.namaUmum)
        setValueNmLatin(row.namaLatin)
        setValueHsCode(row.kodeHs)
        setValueBentuk(row.bentuk)
        setValueSatuan(row.kodeSatuan)
        setValuePopulasi(row.populasi)
        // setValueUrSatuan(row.uraianSatuan)
        setValueKdTarif(row.kodeTarif)
        // GetSatuanIkan(row.kodeSatuan)
        GetBentukIkan(row.bentuk)
        // setValueJumlah(row.jumlah)
        // setvalueNettoDtl(row.netto)
        // setValueNilaiDtl(row.nilai)
        setShowEditKomoditi(true)
    }

    const [showViewKomoditi, setShowViewKomoditi] = useState(false);
    const handleCloseViewKomoditi = () => setShowViewKomoditi(false);
    const handleShowViewKomoditi = (row) => {
        setDetilKomoditi(row)
        setShowViewKomoditi(true)
    }

    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const handleCloseConfirmDelete = () => setShowConfirmDelete(false)
    const handleShowConfirmDelete = (row) => {
        setDetilKomoditi(row)
        setShowConfirmDelete(true)
    }
    const [showDeleteSuccess, setShowDeleteSuccess] = useState(false)
    const [showDeleteFailed, setShowDeleteFailed] = useState(false)

    const [detilKomoditi, setDetilKomoditi] = useState(null)

    const [loadingSave, setLoadingSave] = useState(false)
    const [showConfirmSave, setShowConfirmSave] = useState(false)
    const handleCloseConfirmSave = () => setShowConfirmSave(false)
    const handleShowConfirmSave = () => setShowConfirmSave(true)

    const [showSaveSuccess, setShowSaveSucces] = useState(false)
    const [showSaveFailed, setShowSaveFailed] = useState(false)

    let masterService = useMemo(() => new MasterService(), [])
    let nonLalinService = useMemo(() => new NonlalinService(), [])

    const [loading, setLoading] = useState()
    const [listDataDetail, setListDataDetail] = useState([])

    const [valueSeri, setValueSeri] = useState(0)
    const [valueIkanOpt, setValueIkanOpt] = useState(null)
    const [valueIdIkan, setValueIdIkan] = useState(null)
    const [valueNmDagang, setValueNmDagang] = useState(null)
    const [valueNmUmum, setValueNmUmum] = useState(null)
    const [valueNmLatin, setValueNmLatin] = useState(null)
    const [valueHsCode, setValueHsCode] = useState(null)
    const [valueBentuk, setValueBentuk] = useState(null)
    const [valueUrBentuk, setValueUrBentuk] = useState(null)
    // const [valueJumlah, setValueJumlah] = useState(null)
    const [valueSatuan, setValueSatuan] = useState(null)
    // const [valueUrSatuan, setValueUrSatuan] = useState(null)
    // const [valueNettoDtl, setvalueNettoDtl] = useState(null)
    // const [valueNilaiDtl, setValueNilaiDtl] = useState(null)
    const [valueKdTarif, setValueKdTarif] = useState(null)
    const [valuePopulasi, setValuePopulasi] = useState(null)

    useEffect(() => {
        if (!dataDetil) return
        setLoading(true)
        setListDataDetail(dataDetil.data)
        // setTotalData(dataKomoditi.totalData)
        setLoading(false)
    }, [dataDetil])

    async function loadOptionIkan(search, loadedOption, { page = 1 }) {
        const response = await masterService.listMasterIkanTrader(localStorage.getItem("kodeTrader"), search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const onChangeIkanOpt = e => {
        // console.log(e)
        setValueIkanOpt(e)
        setValueIdIkan(e.idIkan)
        setValueNmDagang(e.nmDagang)
        setValueNmUmum(e.nmUmum)
        setValueNmLatin(e.nmLatin)
        setValueHsCode(e.hscode)
        setValueBentuk(e.bentuk)
        setValueSatuan(e.kdSatuan)
        // setValueUrSatuan(e.uraianSatuan)
        setValueKdTarif(e.kdTarif)
        // GetSatuanIkan(e.idSatuan)
        GetBentukIkan(e.bentuk)
    }

    const GetBentukIkan = async (bentuk) => {
        try {
            const response = await masterService.getBentukIkanById(bentuk)
            setValueUrBentuk(response.data.ketBentuk)
        } catch (error) {
            console.log(error)
            setValueUrBentuk(null)
        }
    }

    const [valueBentukOpt, setValueBentukOpt] = useState(null)
    async function loadOptionBentuk(search, loadedOption, { page = 1 }) {
        const response = await masterService.listBentukIkan(null, search, 2, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangeBentukOpt = e => {
        setValueBentukOpt(e)
        setValueBentuk(e.kdBentuk)
    }

    const onChangeNmDagang = e => {
        setValueNmDagang(e.target.value)
    }

    const onChangeNmUmum = e => {
        setValueNmUmum(e.target.value)
    }

    const onChangeNmLatin = e => {
        setValueNmLatin(e.target.value)
    }

    const onChangeHsCode = e => {
        setValueHsCode(e.target.value)
    }

    const onChangePopulasi = e => {
        setValuePopulasi(e.target.value)
    }

    const [kelengkapan, setKelengkapan] = useState({})
    const checkKelengkapan = () => {
        const checkKelengkapan = {}
        if ((localStorage.getItem('role') === '4' || localStorage.getItem('role') === '5')) {
            if (!valueIkanOpt) checkKelengkapan.ikan = 'Data Ikan Wajib Dipilih'
        } else {
            if (!valueNmDagang) checkKelengkapan.ikan = 'Data Ikan Wajib Diisi'
        }
        if (!valuePopulasi) checkKelengkapan.populasi = 'Keterangan/Populasi Wajib Diisi'

        setKelengkapan(checkKelengkapan)
        return Object.keys(checkKelengkapan).length === 0
    }

    const handleClickSimpan = async () => {
        if (checkKelengkapan()) {
            try {
                setLoadingSave(true)
                // let dataheader = JSON.parse(localStorage.getItem('dataHeaderStorage'))
                let nomorAjuStorage = localStorage.getItem('nomorAjuStorage')
                const resNextSeri = await nonLalinService.nextSeriNonlalin('dtl', nomorAjuStorage)
                let jsonDataDetail = {
                    bentuk: valueBentuk,
                    idIkan: valueIdIkan,
                    kodeHs: valueHsCode,
                    kodeSatuan: valueSatuan,
                    namaLatin: valueNmLatin,
                    namaLokal: valueNmDagang,
                    namaUmum: valueNmUmum,
                    kodeTarif: valueKdTarif,
                    populasi: valuePopulasi,
                    trNonlalinDtlPK: {
                        nomorAju: nomorAjuStorage,
                        seri: valueSeri !== 0 ? valueSeri : resNextSeri.data
                    }
                }
                const response = await nonLalinService.saveNonlalinDtl(JSON.stringify(jsonDataDetail))
                if (response.data.kode === '200') {
                    setShowSaveSucces(true)
                    setShowConfirmSave(false)
                    setListDataDetail([...listDataDetail, jsonDataDetail])
                }
                setLoadingSave(false)
                // setCountDtl(countDtl + 1)
            } catch (error) {
                setShowConfirmSave(false)
                setShowSaveFailed(true)
                setLoadingSave(false)
                // console.log(error)
            }
        } else {
            setShowConfirmSave(false)
            setShowSaveFailed(true)
        }
    }

    const handleClickSaveSuccess = () => {
        setValueSeri(0)
        setValueIkanOpt(null)
        setValueIdIkan(null)
        setValueHsCode(null)
        setValueBentuk(null)
        setValueNmDagang(null)
        setValueNmUmum(null)
        setValueSatuan(null)
        setValuePopulasi(null)
        setValueKdTarif(null)
        setLoadingSave(false)
        setShowSaveSucces(false)
        setShowAddKomoditi(false)
        // getPpmDetail(noAju, 0, 10)
        setShowEditKomoditi(false)
        cancelDetil('detil')
        localStorage.setItem('dataDetailStorage', listDataDetail)
    }

    const handleClickSaveFailed = () => {
        setLoadingSave(false)
        setShowSaveFailed(false)
    }

    const handleClickDelete = async () => {
        try {
            let jsonData = {
                nomorAju: detilKomoditi.trNonlalinDtlPK.nomorAju,
                seri: detilKomoditi.trNonlalinDtlPK.seri
            }
            const resDelete = await nonLalinService.deleteNonlalinDtl(jsonData)
            if (resDelete.data.kode === '200') {
                await nonLalinService.deleteNonlalinDtlPeriksaByAjuSeri(detilKomoditi.trNonlalinDtlPK.nomorAju, detilKomoditi.trNonlalinDtlPK.seri)
                setShowConfirmDelete(false)
                setShowDeleteSuccess(true)
            }
        } catch (error) {
            setShowConfirmDelete(false)
            setShowDeleteFailed(true)
        }
    }

    const handleClickDeleteSuccess = () => {
        setShowDeleteSuccess(false)
        setShowConfirmDelete(false)
        cancelDetil('detil')
        localStorage.setItem('dataDetailStorage', listDataDetail)
    }

    const handleClickDeleteFailed = () => {
        setShowDeleteFailed(false)
    }

    const columns = [
        {
            name: 'Seri',
            cell: row => row['trNonlalinDtlPK'].seri,
            grow: 0
        },
        {
            name: 'Kode HS',
            cell: row => row['kodeHs'],
            grow: 0
        },
        {
            name: 'Nama Dagang',
            cell: row => row['namaLokal']
        },
        {
            name: 'Nama Umum',
            cell: row => row['namaUmum']
        },
        {
            name: 'Nama Latin',
            cell: row => row['namaLatin']
        },
        {
            name: 'Keterangan / Populasi',
            cell: row => row['populasi']
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    <div className='row'>
                        <div className='col-12 mb-1'>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Lihat Komoditi</Tooltip>}>
                                <Button size='sm' variant='info' onClick={() => handleShowViewKomoditi(row)}>
                                    <FaEye /> Lihat
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                        {localStorage.getItem('isEditStorage') === '1' ?
                            <>
                                <div className='col-12 mb-1'>
                                    <OverlayTrigger placement="bottom" overlay={
                                        <Tooltip >Ubah Komoditi</Tooltip>}>
                                        <Button size='sm' variant='warning' onClick={() => handleShowEditKomoditi(row)}>
                                            <FaEdit /> Ubah
                                        </Button>
                                    </OverlayTrigger>{' '}
                                </div>
                                <div className='col-12 mb-1'>
                                    <OverlayTrigger placement="bottom" overlay={
                                        <Tooltip >Hapus Komoditi</Tooltip>}>
                                        <Button size='sm' variant='danger' onClick={() => handleShowConfirmDelete(row)}>
                                            <FaTrash /> Hapus
                                        </Button>
                                    </OverlayTrigger>{' '}
                                </div>
                                <div className='col-12 mb-1'>
                                    <OverlayTrigger placement="bottom" overlay={
                                        <Tooltip >Tambah Target Pengujian</Tooltip>}>
                                        <Button size='sm' variant='primary' onClick={() => handleShowTargetUji(row)}>
                                            <FaRegPlusSquare /> Tambah Target Pengujian
                                        </Button>
                                    </OverlayTrigger>{' '}
                                </div>
                            </> : ''
                        }
                    </div>
                </>
            ),
            grow: 1
        }
    ]

    const [showAddTargetUji, setShowTargetUji] = useState(false)
    const handleCloseTargetUji = () => setShowTargetUji(false)
    const handleShowTargetUji = (row) => {
        setDetilKomoditi(row)
        setShowTargetUji(true)
    }

    return (
        <>
            <div className="form-card text-start">
                <div className="row">
                    <div className="col-7">
                        <h6 className="mb-4">Data Pengajuan : {localStorage.getItem('nomorAjuStorage')} </h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-7">
                        <h5 className="mb-4">Detil</h5>
                    </div>
                </div>
                <div className="row">
                    {
                        localStorage.getItem('isEditStorage') === '1' ?
                            <div className="col-7">
                                <Button type="button" variant="primary" size="sm" onClick={handleShowAddKomoditi}><FaPlus />Tambah Detil</Button>
                            </div> : ''
                    }
                </div>
            </div>
            <div className="table-responsive border-bottom my-3">
                {(loading && <Spinner />)}
                <DataTable
                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                    columns={columns}
                    data={listDataDetail}
                    highlightOnHover
                    pagination
                    persistTableHead={true}
                    expandableRows
                    expandOnRowDoubleClicked
                    expandableIcon={{
                        collapsed: <FaPlus size={12} color="blue" />, // Custom expand icon
                        expanded: <FaMinus size={12} color="red" />,   // Custom collapse icon
                    }}
                    expandableRowsComponent={({ data }) => <ExpandableComponentNonLalinPeriksa data={data} />}
                    expandableRowExpanded={() => true}
                />
            </div>
            {
                localStorage.getItem('isEditStorage') === '1' ? <>
                    <button type="button" name="next" className="btn btn-primary next action-button float-end btn-sm" value="Next" onClick={() => saveDetil('dokumen')} ><FaSave /> Simpan & Lanjutkan</button>
                    <button type="button" name="previous" className="btn btn-dark previous action-button-previous float-end me-1 btn-sm" value="Previous" onClick={() => cancelDetil('entitas')} ><FaArrowLeft /> Sebelumnya</button>
                </> : ''
            }

            {/* modal add */}
            <Modal
                show={showAddKomoditi}
                onHide={handleCloseAddKomoditi}
                backdrop="static"
                keyboard={false}
                size='lg'
            >
                <Modal.Header closeButton>
                    <Modal.Title><h5>Tambah Komoditi</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {(localStorage.getItem('role') === '4' || localStorage.getItem('role') === '5') &&
                        <div className="row mb-3">
                            <label className="col-sm-2 ">Kode Ikan</label>
                            <div className="col-sm-6">
                                <input type="text" className="form-control-sm" name="id_ikan" placeholder="Kode Ikan" defaultValue={valueIdIkan} disabled />
                            </div>
                        </div>
                    }
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nama Dagang<span className="text-danger">*</span></label>
                        <div className="col-sm-8">
                            {(localStorage.getItem('role') === '4' || localStorage.getItem('role') === '5') &&
                                <AsyncPaginate
                                    loadOptions={loadOptionIkan}
                                    value={valueIkanOpt}
                                    getOptionLabel={(option) => option.nmDagang + '-' + option.nmUmum + '-' + option.nmLatin + '-' + option.hscode}
                                    getOptionValue={(option) => option.idIkan}
                                    additional={{
                                        page: 1
                                    }}
                                    onChange={onChangeIkanOpt}
                                />
                            }
                            {
                                (localStorage.getItem('role') === '2' || localStorage.getItem('role') === '3' || localStorage.getItem('role') === '6' || localStorage.getItem('role') === '7') &&
                                <input type="text" className="col-sm-12 form-control-sm" name="nm_umum" placeholder="Nama Dagang" value={valueNmDagang} onChange={onChangeNmDagang} />
                            }
                            {kelengkapan.ikan && <div className='text-danger'>{kelengkapan.ikan}</div>}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nama Umum</label>
                        <div className="col-sm-8">
                            {(localStorage.getItem('role') === '4' || localStorage.getItem('role') === '5') &&
                                <input type="text" className="col-sm-12 form-control-sm" name="nm_umum" placeholder="Nama Umum" value={valueNmUmum} disabled />
                            }
                            {
                                (localStorage.getItem('role') === '2' || localStorage.getItem('role') === '3' || localStorage.getItem('role') === '6' || localStorage.getItem('role') === '7') &&
                                <input type="text" className="col-sm-12 form-control-sm" name="nm_umum" placeholder="Nama Umum" value={valueNmUmum} onChange={onChangeNmUmum} />
                            }
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nama Latin</label>
                        <div className="col-sm-8">
                            {(localStorage.getItem('role') === '4' || localStorage.getItem('role') === '5') &&
                                <input type="text" className="col-sm-12 form-control-sm" name="nm_latin" placeholder="Nama Latin" value={valueNmLatin} disabled />
                            }
                            {
                                (localStorage.getItem('role') === '2' || localStorage.getItem('role') === '3' || localStorage.getItem('role') === '6' || localStorage.getItem('role') === '7') &&
                                <input type="text" className="col-sm-12 form-control-sm" name="nm_latin" placeholder="Nama Latin" value={valueNmLatin} onChange={onChangeNmLatin} />
                            }
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Kode HS</label>
                        <div className="col-sm-8">
                            {(localStorage.getItem('role') === '4' || localStorage.getItem('role') === '5') &&
                                <input type="text" className="col-sm-6 form-control-sm" name="hs_code" placeholder="Kode HS" value={valueHsCode} disabled />
                            }
                            {
                                (localStorage.getItem('role') === '2' || localStorage.getItem('role') === '3' || localStorage.getItem('role') === '6' || localStorage.getItem('role') === '7') &&
                                <input type="text" className="col-sm-6 form-control-sm" name="hs_code" placeholder="Kode HS" value={valueHsCode} onChange={onChangeHsCode} />
                            }
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Bentuk</label>
                        <div className="col-sm-8">
                            {(localStorage.getItem('role') === '4' || localStorage.getItem('role') === '5') &&
                                <input type="text" className="form-control-sm" name="bentuk" placeholder="Bentuk" value={valueUrBentuk} disabled />
                            }
                            {
                                (localStorage.getItem('role') === '2' || localStorage.getItem('role') === '3' || localStorage.getItem('role') === '6' || localStorage.getItem('role') === '7') &&
                                <AsyncPaginate
                                    loadOptions={loadOptionBentuk}
                                    value={valueBentukOpt}
                                    getOptionLabel={(option) => option.ketBentuk}
                                    getOptionValue={(option) => option.kdBentuk}
                                    additional={{
                                        page: 1
                                    }}
                                    onChange={onChangeBentukOpt}
                                />
                            }
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Keterangan / Populasi <span className='text-danger'> *</span></label>
                        <div className="col-sm-6">
                            <input type="text" className="col-sm-12 form-control-sm" name="nm_latin" placeholder="Populasi" value={valuePopulasi} onChange={onChangePopulasi} />
                            {kelengkapan.populasi && <div className='text-danger'>{kelengkapan.populasi}</div>}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size='sm' onClick={handleCloseAddKomoditi}>
                        <FaChevronCircleLeft /> Close
                    </Button>
                    <Button variant="primary" size='sm' onClick={handleShowConfirmSave}><FaSave /> Simpan</Button>
                </Modal.Footer>
            </Modal>

            {/* modal edit */}
            <Modal
                show={showEditKomoditi}
                onHide={handleCloseEditKomoditi}
                backdrop="static"
                keyboard={false}
                size='lg'
            >
                <Modal.Header closeButton>
                    <Modal.Title><h5>Ubah Komoditi</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {(localStorage.getItem('role') === '4' || localStorage.getItem('role') === '5') &&
                        <div className="row mb-3">
                            <label className="col-sm-2 ">Kode Ikan</label>
                            <div className="col-sm-6">
                                <input type="text" className="form-control-sm" name="id_ikan" placeholder="Kode Ikan" value={valueIdIkan} readOnly />
                            </div>
                        </div>
                    }
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nama Dagang<span className="text-danger">*</span></label>
                        <div className="col-sm-8">
                            {(localStorage.getItem('role') === '4' || localStorage.getItem('role') === '5') &&
                                <AsyncPaginate
                                    loadOptions={loadOptionIkan}
                                    value={valueIkanOpt}
                                    getOptionLabel={(option) => option.nmDagang + '-' + option.nmUmum + '-' + option.nmLatin + '-' + option.hscode}
                                    getOptionValue={(option) => option.idIkan}
                                    additional={{
                                        page: 1
                                    }}
                                    onChange={(selectedOption) => onChangeIkanOpt(selectedOption)}
                                />
                            }
                            {
                                (localStorage.getItem('role') === '2' || localStorage.getItem('role') === '3' || localStorage.getItem('role') === '6' || localStorage.getItem('role') === '7') &&
                                <input type="text" className="col-sm-12 form-control-sm" name="nm_umum" placeholder="Nama Dagang" value={valueNmDagang} onChange={onChangeNmDagang} />
                            }
                            {kelengkapan.ikan && <div className='text-danger'>{kelengkapan.ikan}</div>}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nama Umum</label>
                        <div className="col-sm-8">
                            {(localStorage.getItem('role') === '4' || localStorage.getItem('role') === '5') &&
                                <input type="text" className="col-sm-12 form-control-sm" name="nm_umum" placeholder="Nama Umum" value={valueNmUmum} readOnly />
                            }
                            {
                                (localStorage.getItem('role') === '2' || localStorage.getItem('role') === '3' || localStorage.getItem('role') === '6' || localStorage.getItem('role') === '7') &&
                                <input type="text" className="col-sm-12 form-control-sm" name="nm_umum" placeholder="Nama Umum" value={valueNmUmum} onChange={onChangeNmUmum} />
                            }
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nama Latin</label>
                        <div className="col-sm-6">
                            {(localStorage.getItem('role') === '4' || localStorage.getItem('role') === '5') &&
                                <input type="text" className="col-sm-12 form-control-sm" name="nm_latin" placeholder="Nama Latin" value={valueNmLatin} readOnly />
                            }
                            {
                                (localStorage.getItem('role') === '2' || localStorage.getItem('role') === '3' || localStorage.getItem('role') === '6' || localStorage.getItem('role') === '7') &&
                                <input type="text" className="col-sm-12 form-control-sm" name="nm_latin" placeholder="Nama Latin" value={valueNmLatin} onChange={onChangeNmLatin} />
                            }
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Kode HS</label>
                        <div className="col-sm-4">
                            {(localStorage.getItem('role') === '4' || localStorage.getItem('role') === '5') &&
                                <input type="text" className="col-sm-6 form-control-sm" name="hs_code" placeholder="Kode HS" value={valueHsCode} readOnly />
                            }
                            {
                                (localStorage.getItem('role') === '2' || localStorage.getItem('role') === '3' || localStorage.getItem('role') === '6' || localStorage.getItem('role') === '7') &&
                                <input type="text" className="col-sm-6 form-control-sm" name="hs_code" placeholder="Kode HS" value={valueHsCode} onChange={onChangeHsCode} />
                            }
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Bentuk</label>
                        <div className="col-sm-4">
                            {(localStorage.getItem('role') === '4' || localStorage.getItem('role') === '5') &&
                                <input type="text" className="form-control-sm" name="bentuk" placeholder="Bentuk" value={valueUrBentuk} readOnly />
                            }
                            {
                                (localStorage.getItem('role') === '2' || localStorage.getItem('role') === '3' || localStorage.getItem('role') === '6' || localStorage.getItem('role') === '7') &&
                                <AsyncPaginate
                                    loadOptions={loadOptionBentuk}
                                    value={valueBentukOpt}
                                    getOptionLabel={(option) => option.ketBentuk}
                                    getOptionValue={(option) => option.kdBentuk}
                                    additional={{
                                        page: 1
                                    }}
                                    onChange={onChangeBentukOpt}
                                />
                            }
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Keterangan / Populasi <span className='text-danger'> *</span></label>
                        <div className="col-sm-6">
                            <input type="text" className="col-sm-12 form-control-sm" name="nm_latin" placeholder="Populasi" value={valuePopulasi} onChange={onChangePopulasi} />
                            {kelengkapan.populasi && <div className='text-danger'>{kelengkapan.populasi}</div>}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size='sm' onClick={handleCloseEditKomoditi}>
                        <FaChevronCircleLeft /> Close
                    </Button>
                    <Button variant="primary" size='sm' onClick={handleShowConfirmSave}><FaSave /> Simpan</Button>
                </Modal.Footer>
            </Modal>

            {/* modal view */}
            <Modal
                show={showViewKomoditi}
                onHide={handleCloseViewKomoditi}
                backdrop="static"
                keyboard={false}
                scrollable={true}
                size='lg'
            >
                <Modal.Header closeButton>
                    <Modal.Title><h5>Lihat Komoditi</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 ">Kode Ikan</label>
                        <div className="col-sm-6">
                            <input type="text" className="form-control-sm" name="id_ikan" placeholder="Kode Ikan" defaultValue={detilKomoditi !== null ? detilKomoditi.idIkan : ''} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nama Dagang</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nm_lokal" placeholder="Nama Lokal" defaultValue={detilKomoditi !== null ? detilKomoditi.namaLokal : ''} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nama Umum</label>
                        <div className="col-sm-6">
                            <input type="text" className="col-sm-12 form-control-sm" name="nm_umum" placeholder="Nama Umum" defaultValue={detilKomoditi !== null ? detilKomoditi.namaUmum : ''} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nama Latin</label>
                        <div className="col-sm-6">
                            <input type="text" className="col-sm-12 form-control-sm" name="nm_latin" placeholder="Nama Latin" defaultValue={detilKomoditi !== null ? detilKomoditi.namaLatin : ''} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Kode HS</label>
                        <div className="col-sm-4">
                            <input type="text" className="col-sm-6 form-control-sm" name="hs_code" placeholder="Kode HS" defaultValue={detilKomoditi !== null ? detilKomoditi.kodeHs : ''} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Bentuk</label>
                        <div className="col-sm-4">
                            {detilKomoditi !== null ? <Bentuk idBentuk={detilKomoditi.bentuk} /> : ''}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Keterangan / Populasi <span className='text-danger'> *</span></label>
                        <div className="col-sm-6">
                            <input type="text" className="col-sm-12 form-control-sm" name="nm_latin" placeholder="Populasi" value={detilKomoditi !== null ? detilKomoditi.populasi : ''} disabled />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size='sm' onClick={handleCloseViewKomoditi}>
                        <FaChevronLeft /> Close
                    </Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmSave &&
                <SweetAlert
                    title="Simpan Data Komoditas?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Simpan"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSimpan}
                    onCancel={handleCloseConfirmSave}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSaveSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data Komoditas Berhasil"
                    onConfirm={handleClickSaveSuccess}
                    btnSize="sm"
                />
            }
            {
                showSaveFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Komoditas Gagal"
                    onConfirm={handleClickSaveFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
            {
                showConfirmDelete &&
                <SweetAlert
                    title="Hapus Data Komoditas?"
                    warning
                    showCancel
                    confirmBtnText="Hapus"
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickDelete}
                    onCancel={handleCloseConfirmDelete}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSave}
                >Data Komoditi : {detilKomoditi !== null ? detilKomoditi.namaLokal : ''}</SweetAlert>
            }
            {
                showDeleteSuccess &&
                <SweetAlert
                    success
                    title="Hapus Data Komoditas Berhasil"
                    onConfirm={handleClickDeleteSuccess}
                    btnSize="sm"
                />
            }
            {
                showDeleteFailed &&
                <SweetAlert
                    danger
                    title="Hapus Data Komoditas Gagal"
                    onConfirm={handleClickDeleteFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }

            {/* modal tambah target uji */}
            <ModalTargetUji showAddTargetUji={showAddTargetUji} handleCloseTargetUji={handleCloseTargetUji} datakomoditi={detilKomoditi} />
        </>
    )
}

export default ViewNonLalinDetil